import '../background.css';

function Background() {
  const Star = () => {
    return (
      <div className="container">
        <div className="star"></div>
      </div>
    );
  };

  return (
    <div className="App">
      <div className="stars">
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
      </div>
    </div>
  );
}

export default Background;
